import React from "react";
import RevealLinks from "./link";

const Form = () => {
  return (
    <div className="font-[sans-serif] max-w-6xl max-lg:max-w-3xl mx-auto p-4 mt-16 mb-3">
      <div className="bg-black shadow-[0_2px_10px_-3px_rgba(6,81,237,0.3)] rounded p-8">
        <div className="grid lg:grid-cols-2 items-start gap-12">
          <form className="space-y-3 text-gray-200">
            <input
              type="text"
              placeholder="Name"
              className="w-full bg-stone-800 font-varelaround rounded-[8px] py-3 px-6 text-sm focus:outline-none"
            />
            <input
              type="email"
              placeholder="Email"
              className="w-full bg-stone-800 font-varelaround rounded-[8px] py-3 px-6 text-sm focus:outline-none"
            />
            <input
              type="text"
              placeholder="Phone No."
              className="w-full bg-stone-800 font-varelaround rounded-[8px] py-3 px-6 text-sm focus:outline-none"
            />
            <textarea
              placeholder="Message"
              rows="6"
              className="w-full bg-stone-800 font-varelaround rounded-[8px] px-6 text-sm pt-3 focus:outline-none"
            ></textarea>
            <button
              type="button"
              className="text-white bg-[#FC00A1] hover:bg-[#FC00A1] rounded-[10px] font-varelaround text-sm px-6 py-3 mt-6"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16px"
                height="16px"
                fill="currentColor"
                className="mr-2 inline"
                viewBox="0 0 548.244 548.244"
              >
                <path
                  fillRule="evenodd"
                  d="M392.19 156.054 211.268 281.667 22.032 218.58C8.823 214.168-.076 201.775 0 187.852c.077-13.923 9.078-26.24 22.338-30.498L506.15 1.549c11.5-3.697 24.123-.663 32.666 7.88 8.542 8.543 11.577 21.165 7.879 32.666L390.89 525.906c-4.258 13.26-16.575 22.261-30.498 22.338-13.923.076-26.316-8.823-30.728-22.032l-63.393-190.153z"
                  clipRule="evenodd"
                />
              </svg>
              Send Message
            </button>
          </form>

          <div>
            <div className="grid place-items-center md:grid-cols-2 gap-12">
              <div className="flex items-start bg-black">
                <div className="shadow-[0_0px_2px_0px_rgba(6,81,237,0.3)] rounded px-3 py-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 fill-[#FC00A1]"
                    viewBox="0 0 512 512"
                  >
                    <path d="M341.476 338.285c54.483-85.493 47.634-74.827 49.204-77.056C410.516 233.251 421 200.322 421 166 421 74.98 347.139 0 256 0 165.158 0 91 74.832 91 166c0 34.3 10.704 68.091 31.19 96.446l48.332 75.84C118.847 346.227 31 369.892 31 422c0 18.995 12.398 46.065 71.462 67.159C143.704 503.888 198.231 512 256 512c108.025 0 225-30.472 225-90 0-52.117-87.744-75.757-139.524-83.715zm-194.227-92.34a15.57 15.57 0 0 0-.517-.758C129.685 221.735 121 193.941 121 166c0-75.018 60.406-136 135-136 74.439 0 135 61.009 135 136 0 27.986-8.521 54.837-24.646 77.671-1.445 1.906 6.094-9.806-110.354 172.918L147.249 245.945zM256 482c-117.994 0-195-34.683-195-60 0-17.016 39.568-44.995 127.248-55.901l55.102 86.463a14.998 14.998 0 0 0 25.298 0l55.101-86.463C411.431 377.005 451 404.984 451 422c0 25.102-76.313 60-195 60z" />
                    <path d="M256 91c-41.355 0-75 33.645-75 75s33.645 75 75 75 75-33.645 75-75-33.645-75-75-75zm0 120c-24.813 0-45-20.187-45-45s20.187-45 45-45 45 20.187 45 45-20.187 45-45 45z" />
                  </svg>
                </div>
                <div className="ml-6">
                  <h4 className="text-gray-200 text-base font-bold font-varelaround">
                    Visit Us
                  </h4>
                  <p className="text-sm text-gray-400 mt-1 font-varelaround">
                    VIT AP University
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-black">
                <div className="shadow-[0_0px_2px_0px_rgba(6,81,237,0.3)] rounded px-3 py-2 font-varelaround">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 fill-[#ff72cb]"
                    viewBox="0 0 512 512"
                  >
                    <path d="M256 0C114.624 0 0 114.624 0 256s114.624 256 256 256 256-114.624 256-256S397.376 0 256 0zm75 331.936c0 8.192-6.528 14.816-14.816 14.816H195.84c-8.192 0-14.816-6.624-14.816-14.816V180.064c0-8.192 6.624-14.816 14.816-14.816h120.32c8.192 0 14.816 6.624 14.816 14.816v151.872zm.064-189.056H181.184c-8.192 0-14.88 6.624-14.88 14.816v189.056c0 8.192 6.688 14.816 14.88 14.816h149.312c8.192 0 14.816-6.624 14.816-14.816V157.696c0-8.192-6.624-14.816-14.816-14.816zm-66.624 63.808c17.92 0 32.448 14.624 32.448 32.576s-14.528 32.448-32.448 32.448c-17.92 0-32.448-14.528-32.448-32.448 0-17.952 14.528-32.576 32.448-32.576zm0 49.792c9.6 0 17.28-7.744 17.28-17.28s-7.744-17.408-17.28-17.408c-9.6 0-17.28 7.744-17.28 17.408s7.744 17.28 17.28 17.28zm59.52 14.112c5.376 0 9.728 4.352 9.728 9.728s-4.352 9.728-9.728 9.728H185.6c-5.376 0-9.728-4.352-9.728-9.728s4.352-9.728 9.728-9.728h101.28zm11.2 0" />
                  </svg>
                </div>
                <div className="ml-6">
                  <h4 className="text-gray-200 text-base font-bold font-varelaround">
                    Email Us
                  </h4>
                  <p className="text-sm text-gray-400 mt-1 font-varelaround">
                    csi.society@vitap.ac.in
                  </p>
                </div>
              </div>
            </div>

            <div className="grid">
              <RevealLinks />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
